<template>
  <div>
    <b-button :class="propOrdensServico.mensalista_id 
                ? 'btn-receber btn-receber-mensalista' : 'btn-receber'"
              :disabled="validaBtnReceber"
              @click="showModal(propOrdensServico)">
      Receber
    </b-button>
    <b-modal :id="`${propOrdensServico.cx_pedido_id}`"
             centered
             size="xl"
             title="Informações sobre pagamento"
             header-bg-variant="secondary"
             header-text-variant="white">
      <div class="container">
        <div v-for="(item, index) in pagamento.itens"
             :key="index"
             class="parcela">
          <div class="row">
            <label class="mt-4 mb-2 col-12">
              Valor recebido
            </label>
            <input v-model="item.valor"
                   v-money="money"
                   class="valor-recebido ml-3 col-2 pt-2 pb-2"
                   maxlength="16"
                   size="sm"
                   @change="calculaRecebido">
            <div class="form-check form-check-inline col-9">
              <b-radio-group :id="`tipo_lancameno_${Math.random()}`"
                             v-model="item.forma_pagamento"
                             class="ml-3"
                             :options="tipoPagamento"
                             value-field="item"
                             text-field="name" />
            </div>
            <div v-if="pagamento.itens.length > 1"
                 class="align-self-lg-center"
                 @click="excluirPagamento(index)">
              <icon-svg icon="trash"
                        class="icons--red icon--sm" />
            </div>    
          </div>
        </div>
        <b-button v-if="pagamento.itens.length <= 2"
                  id="addItens"
                  v-b-modal.modal-1
                  class="mt-4 p-2 pl-3 pr-3 w-100"
                  variant="outline-primary"
                  @click="addParcela">
          <IconSvg class="icon-add-new"
                   icon="add" />
          Adicionar valor e forma de pagamento
        </b-button> 
        <div class="pagamento">
          <div class="pagamento-entrada">
            <span>Total</span>
            <span class="pagamento-valor">
              <input v-money="money"
                     :value="pagamento.valor_total"
                     class="text-right"
                     disabled
                     @click="showInfos(item)">
            </span>
          </div>
          <div v-if="pagamento.itens.length <= 1 &&
                 pagamento.itens[0].forma_pagamento === 'Dinheiro' &&
                 valorRecebido > pagamento.valor_total"
               class="pagamento-troco">
            <span>Troco</span>
            <div class="pagamento-valor">
              <input v-money="money"
                     :value="valorRecebido - pagamento.valor_total"
                     class="text-right"
                     disabled
                     @click="showInfos(item)">
            </div>
          </div>
        </div>
      </div>

      <template v-slot:modal-footer="{ close }">
        <button type="button"
                class="btn btn-close-modal"
                @click="() =>close()">
          Voltar
        </button>
        <button v-if="propOrdensServico.lancamentosAvulso"
                type="button"
                :disabled="disabledBtn"
                class="btn btn-secondary"
                @click="salvarPagamento">
          Salvar pagamento
        </button>
        <b-button-group v-if="propOrdensServico.ordemServico">
          <b-dropdown right                      
                      split
                      text="Salvar"
                      @click="salvarPagamento">
            <b-dropdown-item @click="salvarPagamento">
              Salvar pagamento
            </b-dropdown-item>
            <b-dropdown-item @click="imprimirReciboOS(propOrdensServico.ordemServico)">
              Salvar pagamento e imprimir
            </b-dropdown-item>
          </b-dropdown>
        </b-button-group>
      </template>
    </b-modal>
  </div>
</template>

<script>

  // Importes
  import { VMoney } from 'v-money'

  // Services
  import PagamentoService from '../pagamentoService'
  import RecibosService from '@/services/Registros/RecibosService'

  // Vuex
  import { mapGetters } from 'vuex'

  export default ({
    name: 'Pagamento',
    components: {
    },
    directives: {
      money: VMoney
    },
    props: {
      propOrdensServico: {type: Object, default: null},
    },
    data () {
      return {
        pagamento: {
          tipo: "A vista",
          qt_parcelas: "1",
          id_pedido: this.propOrdensServico.cx_pedido_id,
          valor_total: 0,
          itens: []
        },
        valorRecebido: 'R$ 0,00',
        tipoPagamento: [
          {item: "Dinheiro", name: "Dinheiro"},
          {item: "Cartão de Crédito", name: "Cartão de Crédito"},
          {item: "Cartão de Debito", name: "Cartão de Debito"},
          {item: "Pix", name: "PIX"},
          {item: "Cheque", name: "Cheque"},
          {item: "Outros", name: "Outros"},     
        ],
        money: {
          decimal: ',',
          thousands: '.',
          prefix: 'R$ ',
          suffix: '',
          precision: 2,
          masked: false
        },
        disabledBtn: false
      }
    },
    computed: {
      cxData () {
        return this.$store.state.frenteCaixa.cxData
      },
      ...mapGetters({
        cartorioId: 'auth/getCartorioId',
        cartorioObj: 'auth/getCartorioObj'
      }),
      caixa () {
        return this.$store.state.frenteCaixa.caixa
      },
      validaBtnReceber () {
        const caixaAberto = this.caixa.aberto 
        if (!!this.propOrdensServico.mensalista_id) return false
        if (!caixaAberto) return true
        return false
      }
    },
    created () {
      const valorPedido = this.propOrdensServico.valorTotal

      // fixa valor total do pedido
      this.pagamento.valor_total = valorPedido
      
      // define o valor recebido
      this.pagamento.valorRecebido = valorPedido
      
      // cria item inicial de recebimento
      this.pagamento.itens.push({
        valor: valorPedido,
        forma_pagamento: null,
        parcela: {
          total: 1,
          atual: 1,
        }
      })
    },
    methods: {
      setTipoPg (event) {
        this.pagamento.tipo = event
      },
      setFormaPg (event) {
        this.itemPagamento.forma_pagamento = event
      },
      async salvarPagamento () {
        this.disabledBtn = true
        const validacao = this.validacaoForm()
        if (validacao) {
          displayMessage('error', validacao.msg)
          this.disabledBtn = false
          return false
        } 

        try {
          loader({text: 'Salvando pagamento', active: true})

          await PagamentoService.storePagamento(this.pagamento)
          this.hideModal(this.propOrdensServico)
          await this.$emit('atualizarTabela')

          displayMessage('success', 'Pagamento cadastrado com sucesso')
          return true
        } catch (error) {
          const message = getErrors(error)
          displayMessage('error', 'Erro!', message.message)
        } finally {
          this.disabledBtn = false
          loader({active: false, text: null})
        }
      },
      async imprimirReciboOS (ordemDeServico) {
        const pagamentoSalvo = await this.salvarPagamento()

        if (!pagamentoSalvo) return
   
        const itensInvalidos = ordemDeServico.itens.filter(item => item.flag_cancelado)

        if (itensInvalidos.length > 0) {
          displayMessage('error', '', 'Os itens da ordem de serviço não são válidos para o recibo.')

          setTimeout(() => {
            const btnCancel = document.querySelector('.swal2-cancel')

            if (btnCancel) btnCancel.focus()
          }, 200)

          return
        }

        const payload = {
          os: ordemDeServico,
          cartorio: this.cartorioObj,
          custas: ordemDeServico.itens,
          emolumentos: this.getEmolumentos(ordemDeServico.itens)
        }

        try {
          loader({ text: 'Aguarde...', active: true })

          const url = await RecibosService.reciboSemRegistro(payload)
          window.open(url)

          loader({ text: '', active: false })
        } catch (e) {
          loader({ text: '', active: false })

          displayMessage('error', '', 'Não foi possível imprimir o recibo da ordem de serviço. Tente novamente.')

          setTimeout(() => {
            const btnCancel = document.querySelector('.swal2-cancel')

            if (btnCancel) btnCancel.focus()
          }, 200)
        }
      },
      getEmolumentos (itensOS = []) {
        let emolumentos = []
        let valor = null

        itensOS.forEach(item => {
          const { custa, averbacao, quantidade } = item

          custa.itens.forEach(custaItem => {
            const emolumentoIndex = emolumentos.findIndex(emolumento => emolumento.destino === custaItem.destino)

            if (averbacao > 0) {
              const custaAverbacaoItem = this.custas.find(custaIss => custaIss.codigo === 12)
              const destinatario = custaAverbacaoItem.itens.filter(custa => custa.destino == custaItem.destino)
              valor = (custaItem.valor * quantidade) + (destinatario[0].valor * averbacao)
            } else {
              valor = (custaItem.valor * quantidade)
            }            

            if (emolumentoIndex >= 0) {
              emolumentos[emolumentoIndex].valor += item.valor > 0 ? valor : 0
            } else {
              emolumentos.push({
                destino: custaItem.destino,
                valor: item.valor > 0 ? valor : 0
              })
            }
          })
        })

        emolumentos.push({
          destino: 'total',
          valor: emolumentos.map((e) => e.valor).reduce((a, b) => a + b, 0)
        })

        return emolumentos
      },
      imprimir () {
        window.open(this.urlRecibo)
      },
      validacaoForm () {
        // Atualiza valor recebido
        this.calculaRecebido()

        const formaPg = this.pagamento.itens.find(item => item.forma_pagamento == null)
        const pagamentoZerado = this.pagamento.itens.find(item => item.valor === 'R$ 0,00')

        if (pagamentoZerado) {
          let existeErro = {
            msg: '',
            erro: false,
          }
          existeErro.msg = 'Exclua valores zerados antes de salvar'
          existeErro.erro = true
          return existeErro
        }

        if (formaPg) {
          let existeErro = {
            msg: '',
            erro: false,
          }
          existeErro.msg = 'Defina a forma de pagamento antes de continuar'
          existeErro.erro = true
          return existeErro
        }
        // verifica se há apenas uma forma de pagamento e é dinheiro, caso sim, ajusta o valor recebido em relação posivel troco.
        if (this.pagamento.itens.length === 1 && this.pagamento.itens[0].forma_pagamento === 'Dinheiro') {
          if (this.valorRecebido >= this.pagamento.valor_total) {
            this.valorRecebido = this.pagamento.valor_total
            this.pagamento.itens[0].valor = this.pagamento.valor_total
          }
        }
        // verifica se o valor recebido é igual ao valor do pedido
        if (this.valorRecebido != this.pagamento.valor_total) {
          let existeErro = {
            msg: '',
            erro: false,
          }
          existeErro.msg = 'O valor recebido deve ser igual ao valor do pedido'
          existeErro.erro = true
          return existeErro
        }
      },
      showModal (item) {
        this.$emit('close-modal', item)
        this.$bvModal.show(`${item.cx_pedido_id}`)
      },
      hideModal (item) {
        this.$bvModal.hide(`${item.cx_pedido_id}`)        
      },
      addParcela () {
        this.pagamento.itens.push({
          valor: 'R$ 0,00',
          forma_pagamento: null,
          parcela: {
            total: 1,
            atual: 1,
          }
        })
      },
      calculaRecebido () {
        let valorTotal = 0
        this.pagamento.itens.forEach(item => {
          const result = item.valor ?  item.valor.replace(/\.|,|R/g, '').replace('$', '').trim() : 0
          valorTotal += Number(result)
        })
        this.valorRecebido = valorTotal
      },
      excluirPagamento (index) {
        this.pagamento.itens.splice(index, 1)
      },
      showModalEdicao () {
        console.log('edicao')
      },

    }    
  })

</script>

<style scope>
.icon-add-new {
    fill: #1c7af5;
    width: 20px;
    height: 20px;
    transition: fill 0.2s;
    margin-right: 10px;
  }
  #addItens:hover .icon-add-new {
    fill: white;
  }
  .btn-close-modal {
    background-color: #C7C7C7;
    color: black;
    border: none;
  }
  .btn-close-modal:hover {
    background-color: #C7C7C7;
    color: black;
    border: none;
  }
  .parcela {

    padding-bottom: 1rem;
    border-bottom: solid 1px #C7C7C7;
  }
  .parcelas-title {
    font-size: 18px;
  }
  .valor-recebido {
    outline: none;
  }
  .pagamento {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 10px;
    margin-top: 30px;
    font-size: 20px;
    font-weight: bold;

  }
  .pagamento-entrada {
    display: flex;
    justify-content: space-between;
    background-color: #C7C7C7;
    padding: 10px;
    min-width: 450px;
  }
  .pagamento-troco {
    display: flex;
    justify-content: space-between;
    padding: 10px;
    min-width: 450px;
  }
  .pagamento-valor {
    font-size: 24px;
  }
  .btn-receber {
    background-color: #1A5E38;
    width: 100%;
  }
  .btn-receber-mensalista {
    width: 100%;
  }
</style>